exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-width:48rem) and (max-width:80rem){.mobile-tourist-select-popper{font-size:.625rem}.mobile-tourist-select-popper .el-select-dropdown__list{padding:.25rem 0}.mobile-tourist-select-popper .el-select-dropdown__item{height:2rem;padding:0 .875rem;font-size:.625rem;line-height:2rem}}", ""]);

// exports
